import { type QueryHookOptions, useQuery } from "@apollo/client";
import { StreamMonitoringQuery } from "../graphql/queries";
import type {
  StreamMonitoringQueryType,
  StreamMonitoringQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useStreamMonitoringQuery = (
  options?: QueryHookOptions<
    StreamMonitoringQueryType,
    StreamMonitoringQueryVariablesType
  >
) =>
  useQuery<StreamMonitoringQueryType, StreamMonitoringQueryVariablesType>(
    StreamMonitoringQuery,
    options
  );
